import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import ToastPage from '../../includes/ToastPage';
import '../../../assets/styles/RM.css'
import { useMixBucketContext } from '../../../services/contexts/assetManagement/MixBucketContext';
import ListMixBucketPage from './ListMixBucketPage';
import CreateMixBucketPage from './CreateMixBucketPage';
import DeletedMixBucketPage from './DeletedMixBucketPage';


export default function MixBucketMainPage() {

    const { MixBucketList, getAllMixBucketList, showDeletedMixBucket } = useMixBucketContext()
    const { setCurrModule, allowedFunc } = useLogin()

    const history = useHistory()

    useEffect(() => {
        (async () => {
            try {
                if (allowedFunc.includes(configs.functionList['bucket_management:view_asset_data'])) {
                    setCurrModule(configs.modules.mixBucketMgmt)
                    getAllMixBucketList()
                } else {
                    return history.goBack()
                }
            } catch (error) {

            }
        })()
    }, [])

    // role management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                {showDeletedMixBucket ? <div id='rmContainer' className="rm-container"><DeletedMixBucketPage /></div> :
                    <div id='rmContainer' className="rm-container">
                        <ListMixBucketPage />
                        {allowedFunc.includes(configs.functionList['bucket_management:create_asset']) || allowedFunc.includes(configs.functionList['bucket_management:update_asset']) ?
                            <CreateMixBucketPage />
                            : null}
                        <ToastPage />
                    </div>
                }
            </div>
        </>
    )
}